import { render, staticRenderFns } from "./InterestFreeInstallments.vue?vue&type=template&id=2c501b01&"
import script from "./InterestFreeInstallments.vue?vue&type=script&lang=js&"
export * from "./InterestFreeInstallments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports